import { setInLocalStorage, getFromLocalStorage } from '@/helpers/utils';

const keyPrefix = 'lut-';
const subPrefix = 'sub-';

export const setLookupInLocalStorage = (key, value) =>
  setInLocalStorage(`${keyPrefix}${key}`, value);

export const setSubLookupInLocalStorage = (relatedId, key, value) => {
  const object = getLookupFromLocalStorage(key, true);
  object[relatedId] = value;
  setInLocalStorage(`${subPrefix}${keyPrefix}${key}`, object);
};

export const updateSubLookupInLocalStorage = (id, storageKey, value) => {
  const object = getLookupFromLocalStorage(storageKey, true);
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const index = object[key].findIndex(x => x.id === id);
      object[key][index] = {
        ...object[key][index],
        ...value,
      };
    }
  }
  setInLocalStorage(`${subPrefix}${keyPrefix}${storageKey}`, object);
};

export const getLookupFromLocalStorage = (key, isSubLookup) =>
  getFromLocalStorage(`${isSubLookup ? subPrefix : ''}${keyPrefix}${key}`, isSubLookup ? {} : []);
